module.exports = __webpack_public_path__ + "img/icon-ac.ada0d4fc.png";